<template>
    <div class="d-flex flex-column align-items-center fade-in">
      <content-header title="Dashboard" :sub-title="subTitle" class="w-100 mxw-md px-10"/>
      <member-board />
    </div>
  </template>

<script>
// import { getContrastColor } from '@/utils/helpers';
import MemberBoard from '../../components/members/MemberBoard.vue';

export default {
  name: 'Dashboard',
  components: {
    MemberBoard
  },
  // async mounted() {
  //   // window.addEventListener('resize', this.handleResize);
  //   // this.handleResize();
  //   let textColorPrimary = '';
  //   let textColorSecondary = '';
  //   if (this.entityLevel && this.entityName) {
  //     await this.$store.dispatch('national/getSlugBranding', { entityLevel: this.entityLevel, entityName: this.entityName });
  //     const meta = this.$store.getters['national/getMeta'];
  //     if (meta && meta.primaryColor && meta.secondaryColor) {
  //       textColorPrimary = getContrastColor(meta.primaryColor);
  //       textColorSecondary = getContrastColor(meta.secondaryColor);
  //       document.documentElement.style.setProperty('--highlight-color', meta.primaryColor);
  //       document.documentElement.style.setProperty('--secondary-color', meta.secondaryColor);
  //     } else {
  //       textColorPrimary = getContrastColor(meta.primaryColor);
  //       textColorSecondary = getContrastColor(meta.secondaryColor);
  //       document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
  //       document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
  //     }
  //   } else {
  //     this.$store.commit('national/resetCustom', {});
  //     textColorPrimary = getContrastColor(process.env.VUE_APP_HIGHLIGHT_COLOR);
  //     textColorSecondary = getContrastColor(process.env.VUE_APP_SECONDARY_COLOR);
  //     document.documentElement.style.setProperty('--highlight-color', process.env.VUE_APP_HIGHLIGHT_COLOR);
  //     document.documentElement.style.setProperty('--secondary-color', process.env.VUE_APP_SECONDARY_COLOR);
  //   }
  //   document.documentElement.style.setProperty('--text-color-primary', textColorPrimary);
  //   document.documentElement.style.setProperty('--text-color-secondary', textColorSecondary);
  // },
  data() {
    return {
      subTitle: 'Below are all the member profiles belonging to this account. If you do not have one yet, click on Add Member to find previous profile or register a new profile. Once created, you can view a profile\'s information and registration history by clicking on View. To register a profile to an event or a membership, click on Register',
    };
  }
};
</script>

  <style scoped lang="scss">
  </style>
